import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_TASK_BY_ID_SAGA } from "../sagaTypes";
import { loaderAction, taskFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { taskStatuses } from "../../helpers/taskStatuses";

const request = data => {
    return fetch(`${ url }/get_task_by_id`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetTaskById(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('task_id', args.data.task_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Открываем форму задачи и добавляем в неё данные
            yield put(taskFormAction({
                ...response.task,
                status: { id: response.task.status, name: taskStatuses[response.task.status] },
                open: true
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetTaskById() {
    yield takeLatest(GET_TASK_BY_ID_SAGA, workerGetTaskById);
}